import dayjs from "dayjs";

export const SPEND_PAYMENT_STATUSES = Object.freeze(["pending", "paid"]);

export const SPEND_PAYMENT_STATUS_LABELS = {
  pending: "Pending",
  paid: "Paid",
};

export const SPEND_PAYMENT_STATUS_COLORS = {
  pending: { bg: "#fef3c7", color: "#92400e", border: "#fcd34d" },
  paid: { bg: "#ecfdf5", color: "#047857", border: "#6ee7b7" },
  overdue: { bg: "#fee2e2", color: "#b91c1c", border: "#fca5a5" },
};

/** @param {{ payment_status?: string, payment_due_date?: string|Date|null }} row */
export function resolveSpendDisplayStatus(row) {
  const base = String(row?.payment_status || "pending").toLowerCase();
  if (base === "paid") return "paid";
  const due = row?.payment_due_date;
  if (due) {
    const dueDay = dayjs(typeof due === "string" ? due.slice(0, 10) : due);
    if (dueDay.isValid() && dueDay.isBefore(dayjs(), "day")) return "overdue";
  }
  return "pending";
}
